import React from "react";

class LoadingSpinnerButton extends React.Component{

    constructor(props){
        super(props);
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick(){
        if(this.props.isLoading){
            return false;
        }

        return this.props.action();
    }

    render(){

        const isLoading = this.props.isLoading;
        const spinnerClass = (isLoading) ? "glyphicon glyphicon-refresh glyphicon-refresh-animate" : "glyphicon glyphicon-refresh glyphicon-refresh-animate paused";

        return (
            <span className={"spinner"} style={{userSelect:  'none'}}>
                <span
                    style={{ padding: "7px", display: "inline-block"}}
                    className={spinnerClass}
                    onClick={this.handleClick}
                    ></span>	
                <a href={"#"}></a>
            </span>
            
        );
    }
} 

export default LoadingSpinnerButton;
